import { render, staticRenderFns } from "./zuiminlb.vue?vue&type=template&id=5bb07b06&scoped=true&"
import script from "./zuiminlb.vue?vue&type=script&lang=js&"
export * from "./zuiminlb.vue?vue&type=script&lang=js&"
import style0 from "./zuiminlb.vue?vue&type=style&index=0&id=5bb07b06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb07b06",
  null
  
)

export default component.exports